/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many repetitions are allowed?`)
};

const es_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas repeticiones se permiten?`)
};

const de_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Wiederholungen sind erlaubt?`)
};

const nl_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel herhalingen zijn toegestaan?`)
};

const fr_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de répétitions sont autorisées?`)
};

const it_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante ripetizioni sono consentite?`)
};

const pt_br2_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas repetições são permitidas?`)
};

const pt_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas repetições são permitidas?`)
};

const ja_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何回の繰り返しが許可されていますか？`)
};

const zh_tr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许多少次重复？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq1_q", locale)
	if (locale === "en") return en_tr_faq1_q(inputs)
	if (locale === "es") return es_tr_faq1_q(inputs)
	if (locale === "de") return de_tr_faq1_q(inputs)
	if (locale === "nl") return nl_tr_faq1_q(inputs)
	if (locale === "fr") return fr_tr_faq1_q(inputs)
	if (locale === "it") return it_tr_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq1_q(inputs)
	if (locale === "pt") return pt_tr_faq1_q(inputs)
	if (locale === "ja") return ja_tr_faq1_q(inputs)
	return zh_tr_faq1_q(inputs)
};